import get from "lodash/get";
import Controls from "./Controls/";
import React, {useCallback, useState} from "react";
import Cropper from 'react-easy-crop'
import {getCroppedImg} from "../../utils/canvasUtils";
interface Props {
    classes: any;
    imageSrc:string;
    aspectRatio: number;
    recommended:any;
    handleCroppedImgGenerated:any;
    setCroppedImage:(croppedImg:any)=>any

}
const CropperWrapper = ({imageSrc, aspectRatio, recommended, classes, setCroppedImage, handleCroppedImgGenerated}:Props) =>{
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [rotation, setRotation] = useState(0)
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    const [feedback, setFeedback] = React.useState('')


    const handleChange = (obj:any) =>{
        setCrop(obj)
    }
    const onCropComplete = useCallback(async (croppedArea, croppedAreaPixels) => {
        const croppedImage = await getCroppedImg(
            imageSrc,
            croppedAreaPixels,
            rotation
        )
        handleCroppedImgGenerated(croppedImage)
        setCroppedAreaPixels(croppedAreaPixels)
        if(get(croppedAreaPixels, 'width') >= recommended.width && get(croppedAreaPixels, 'height') >= recommended.height){
            setFeedback('success')
        }else{
            setFeedback('warning')
        }
    }, [])

    const showCroppedImage = useCallback(async () => {
        try {
            const croppedImage = await getCroppedImg(
                imageSrc,
                croppedAreaPixels,
                rotation
            )
            setCroppedImage(croppedImage)
        } catch (e) {
            console.error(e)
        }
    }, [imageSrc, croppedAreaPixels, rotation])

    return (
        <div>
            <div className={classes.cropContainer}>
                <Cropper
                    image={imageSrc}
                    crop={crop}
                    rotation={rotation}
                    zoom={zoom}
                    aspect={aspectRatio}
                    onCropChange={handleChange}
                    onRotationChange={setRotation}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                />
            </div>
            <div style={{padding:'15px 0 0',  justifyContent:'flex-start'}}>
                <div style={{ zIndex:3, color: feedback  === 'success' ? 'green': 'orange'}}>{get(croppedAreaPixels, 'width')}px x {get(croppedAreaPixels, 'height')}px</div>
                <p><i>Recommended dimensions are at least <strong>{recommended.width}px x {recommended.height}px</strong></i></p>
            </div>
            <Controls
                zoom={zoom}
                setZoom={setZoom}
                rotation={rotation}
                setRotation={setRotation}
                showCroppedImage={showCroppedImage}
                classes={classes}/>
        </div>
    )
}

export default CropperWrapper;